var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 19,
    viewBox: "0 0 28 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.000976562 0H27.9996V19H0.000976562V0Z",
    fill: "#00008B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.00095 10.9248L7.40548 12.2066L8.64192 11.7292L7.91081 12.8509L9.04779 13.5377L7.73072 13.6539L7.91215 14.9877L7.00095 14.0124L6.08975 14.9877L6.27118 13.6539L4.9541 13.5377L6.09109 12.8509L5.35863 11.7292L6.59642 12.2066L7.00095 10.9248Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0011 13.2312L21.1933 13.8427L21.7819 13.6156L21.4339 14.1491L21.9755 14.4761L21.3478 14.5322L21.4339 15.1669L21.0011 14.7018L20.567 15.1669L20.653 14.5322L20.0254 14.4761L20.567 14.1491L20.2189 13.6156L20.8076 13.8427L21.0011 13.2312Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0011 3.73193L21.1933 4.34206L21.7819 4.11497L21.4339 4.64849L21.9755 4.9768L21.3478 5.03152L21.4339 5.66627L21.0011 5.20252L20.567 5.66627L20.653 5.03152L20.0254 4.9768L20.567 4.64849L20.2189 4.11497L20.8076 4.34206L21.0011 3.73193Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.1101 6.6416L24.3036 7.25172L24.8923 7.02464L24.5442 7.55815L25.0858 7.8851L24.4582 7.94119L24.5442 8.57594L24.1101 8.11082L23.6774 8.57594L23.7634 7.94119L23.1357 7.8851L23.6774 7.55815L23.3293 7.02464L23.9179 7.25172L24.1101 6.6416Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.3998 9.49927L22.553 9.87957L22.9548 9.90966L22.6471 10.1751L22.7425 10.5731L22.3998 10.357L22.0571 10.5731L22.1538 10.1751L21.8447 9.90966L22.2479 9.87957L22.3998 9.49927Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4998 5.21606L17.6933 5.82619L18.2819 5.5991L17.9339 6.13262L18.4755 6.46093L17.8478 6.51565L17.9339 7.1504L17.4998 6.68665L17.067 7.1504L17.153 6.51565L16.5254 6.46093L17.067 6.13262L16.7189 5.5991L17.3076 5.82619L17.4998 5.21606Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.83375 0H8.16686V2.37483H13.9996V4.74966H8.16686V7.12449H5.83375V4.74966H0.000976562V2.37483H5.83375V0Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.000976562 0H1.56534L13.9996 6.32832V7.12449H12.4353L0.000976562 0.79617V0Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9996 0H12.4353L0.000976562 6.32832V7.12449H1.56534L13.9996 0.79617V0Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.3001 0H7.70051V2.84952H13.9996V4.27497H7.70051V7.12449H6.3001V4.27497H0.000976562V2.84952H6.3001V0Z",
    fill: "#FF0000"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 0H12.9571L8.29087 2.37483H9.33378L14 0ZM0 0L4.66622 2.37483H3.62331L0 0.53078V0Z",
    fill: "#FF0000"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.000976562 7.12459H1.04389L5.71011 4.74976H4.6672L0.000976562 7.12459ZM14.001 7.12459L9.33476 4.74976H10.3777L14.001 6.59381V7.12459Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.2ba4f654c4aecee45a354616cfbdb2cb.svg";
export { ForwardRef as ReactComponent };